

export function TabPanel({ children, panel,tabselected }) {
    let ishidden = (panel !== tabselected)? 'hidden':'block'
    return (
      <div className={` ${ishidden} transform transition duration-500 ease-in-out py-5 w-full h-full`}>
        {children}
      </div>
    );
  }